import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Table } from 'src/components';
import { onlyNumber, roundFloat } from 'src/core/utils/formater';
import { Modal, Form, Row, Col, Button, Typography, Input } from 'antd';
import newAlert from 'src/components/newAlert';
import { set_alert } from 'src/core/actions/alert';
import { customColumns, customSummary } from './dataStructure/data';
import { EditOutlined } from '@ant-design/icons';

import { start_loading, end_loading } from '../../../core/actions/loader';

const { Text } = Typography;

const MainPage = () => {
  const dispatch = useDispatch();

  const socket = useSelector((state) => state.socket);
  const data_date = useSelector((state) => state.data_date);

  const [tableData, setTableData] = useState([]);
  const [tableDataSum, setTableDataSum] = useState({});
  const [addVisible, setAddVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  const [addForm] = Form.useForm();
  const [deleteForm] = Form.useForm();

  const generateTailan = (month) => {
    socket.on('request_out', (data) => {
      const data_temp = data;
      socket.removeAllListeners('request_out');
      setTableData([]);

      if (data_temp?.status === '0') {
        if ('json_array' in data_temp?.content) {
          setTableData(data_temp.content.json_array);
          setTableDataSum(data_temp.content.sum_data);
          dispatch(set_alert({
            type: 'warning',
            msg: 'ХМ-02(7) хавсралтыг "Бүртгэх" товч даран бөглөнө үү.',
            open: true,
          }));
        } else {
          newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
        }
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }

      dispatch(end_loading({}));
    });
    socket.emit('request_in', {
      channel: 'ts001_02_tailan_control',
      content: { action_type: 'get_sanhuu_hm02_7', month: String(month) },
    });

    dispatch(start_loading({}));
  };

  const deleteValue = (deleteData) => {
    socket.on('request_out', (data) => {
      const data_temp = data;
      socket.removeAllListeners('request_out');

      if (data_temp.status === '0') {
        newAlert({ type: 'success', msg: 'Амжилттай устгагдлаа' });
        generateTailan(data_date.month);
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
        dispatch(end_loading({}));
      }
    });
    socket.emit('request_in', {
      channel: 'ts001_02_tailan_control',
      content: {
        action_type: 'delete_sanhuu_hm02_7',
        id: deleteData.delete_id,
      },
    });

    dispatch(start_loading({}));
  };

  const addValue = (saveData) => {
    socket.on('request_out', (data) => {
      const data_temp = data;
      socket.removeAllListeners('request_out');

      if (data_temp.status === '0') {
        newAlert({ type: 'success', msg: 'Амжилттай хадгалагдлаа' });
        generateTailan(data_date.month);
      } else if (data_temp.status === '5') {
        newAlert({ type: 'error', msg: 'Зөв дүн оруулна уу' });
        dispatch(end_loading({}));
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
        dispatch(end_loading({}));
      }
    });
    socket.emit('request_in', {
      channel: 'ts001_02_tailan_control',
      content: {
        action_type: 'add_sanhuu_hm02_7',
        action_data: saveData,
        month: String(data_date.month),
      },
    });

    dispatch(start_loading({}));
  };

  useEffect(() => {
    if (data_date) {
      generateTailan(data_date.month);
    }
  }, [data_date]);

  const deleteAction = (row) => {
    if (row?.id) {
      deleteForm.setFieldsValue({
        delete_id: row?.id,
      });

      setDeleteVisible(true);
    }
  };

  const editAction = (row) => {
    // Temp values
    let temp_gadaad_uls_ner = '';
    // temp_ner check
    if (row?.gadaad_uls_ner === '---') {
      temp_gadaad_uls_ner = '';
    } else {
      temp_gadaad_uls_ner = row?.gadaad_uls_ner;
    }

    addForm.setFieldsValue({
      gadaad_uls_ner: temp_gadaad_uls_ner,
      dans_id: row?.dans_id,
      tatvar_dans: row?.tatvar_dans,
      tatvar_dans_dun: roundFloat(row?.tatvar_dans_dun),
      tatvar_nogdoh_huvi: roundFloat(row?.tatvar_nogdoh_huvi),
      tatvar_nogdoh_dun: roundFloat(row?.tatvar_nogdoh_dun),
      gadaad_nogdoh_huvi: roundFloat(row?.gadaad_nogdoh_huvi),
    });

    setAddVisible(true);
  };

  const title = () => (
    <>
      <div className="table-title-text-center">
        Гадаад улсад ногдуулан төлсөн албан татварыг төлбөл зохих албан
        татвараас хасаж тооцох мэдээ /ХМ-02(7)/
      </div>
    </>
  );

  return (
    <>
      <div className="table-antd-div tailan-container-1435">
        <Table
          columns={customColumns({
            customDelete: deleteAction,
            customEdit: editAction,
          })}
          dataSource={tableData}
          scroll={
            {
              // y: 'max-content',
              // x: 'max-content',
            }
          }
          summaryList={{
            sumColumn: customSummary,
            sumDataSource: tableDataSum,
          }}
          title={title}
        />
      </div>
      <Modal
        className="custom-modal"
        title="Бүртгэл устгах"
        visible={deleteVisible}
        closable={false}
        maskClosable={false}
        width={500}
        footer={null}
      >
        <DeleteModal
          onClose={() => {
            setDeleteVisible(false);
          }}
          form={deleteForm}
          deleteValue={deleteValue}
        />
      </Modal>
      <Modal
        className="custom-modal"
        title="Бүртгэл шинэчлэх"
        visible={addVisible}
        closable={false}
        maskClosable={false}
        width={750}
        footer={null}
      >
        <EditModal
          onClose={() => {
            setAddVisible(false);
          }}
          form={addForm}
          saveValues={addValue}
        />
      </Modal>
    </>
  );
};

const layout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 15 },
  },
  wrapperCol: {
    xs: { span: 12 },
    sm: { span: 9 },
  },
};

const EditModal = ({
  onClose = () => {},
  form = null,
  saveValues = () => {},
}) => {
  const onFinish = (values) => {
    saveValues(values);
    form.resetFields();
    onClose();
  };

  const onCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <div className="dans-medeelel-container">
      <Form
        form={form}
        onFinish={onFinish}
        className="register-form"
        {...layout}
        // validateMessages={validateMessages}
        size="small"
      >
        <Form.Item name="tatvar_dans" hidden />
        <Form.Item
          name="gadaad_uls_ner"
          label="Гадаад улсын нэр"
          labelAlign="left"
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
        >
          <Input className="w-100" />
        </Form.Item>
        <Form.Item
          name="dans_id"
          label="Татварын жилд гадаад улсад олсон орлого"
          labelAlign="left"
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
        >
          <Text ellipsis>{form.getFieldValue('tatvar_dans')}</Text>
        </Form.Item>
        <Form.Item
          name="tatvar_dans_dun"
          label="Татвар ногдуулах орлого"
          labelAlign="left"
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
          normalize={onlyNumber}
        >
          <Input className="w-100 text-align-r" disabled />
        </Form.Item>
        <Form.Item
          name="tatvar_nogdoh_huvi"
          label="Хувь"
          labelAlign="left"
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
          normalize={onlyNumber}
        >
          <Input className="w-100 text-align-r" disabled />
        </Form.Item>
        <Form.Item
          name="tatvar_nogdoh_dun"
          label="Дүн"
          labelAlign="left"
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
          normalize={onlyNumber}
        >
          <Input className="w-100 text-align-r" disabled />
        </Form.Item>
        <Form.Item
          name="gadaad_nogdoh_huvi"
          label="Гадаад Улсын-Хувь"
          labelAlign="left"
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
          normalize={onlyNumber}
        >
          <Input className="w-100 text-align-r" />
        </Form.Item>
        <Row>
          <Col span={24} className="text-align-r">
            <Form.Item noStyle>
              <Button
                onClick={onCancel}
                className="cancel-btn"
                type="primary"
                shape="round"
              >
                Цуцлах
              </Button>
              <Button
                className="confirm-btn ml-5"
                type="primary"
                shape="round"
                htmlType="submit"
              >
                Хадгалах
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

const DeleteModal = ({
  onClose = () => {},
  form = null,
  deleteValue = () => {},
}) => {
  const onFinish = (values) => {
    deleteValue(values);
    form.resetFields();
    onClose();
  };

  const onCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <div className="dans-medeelel-container">
      <Form
        form={form}
        onFinish={onFinish}
        className="register-form"
        {...layout}
        size="small"
      >
        <Form.Item name="delete_id" hidden />
        <Text>Та энэ үйлдлийг хийхдээ итгэлтэй байна уу?</Text>
        <Row>
          <Col span={24} className="text-align-r">
            <Form.Item noStyle>
              <Button
                onClick={onCancel}
                className="cancel-btn"
                type="primary"
                shape="round"
              >
                Цуцлах
              </Button>
              <Button
                className="confirm-btn ml-5"
                type="primary"
                shape="round"
                htmlType="submit"
              >
                Устгах
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default MainPage;
